import { create } from "zustand";

/** A tour to start once the app reaches `path` (the task's screen). */
interface PendingTour {
  tour: string;
  path: string;
}

interface TrainingState {
  pendingTour: PendingTour | null;
  queueTour: (tour: string, path: string) => void;
  clearPendingTour: () => void;
}

export const useTrainingStore = create<TrainingState>((set) => ({
  pendingTour: null,
  queueTour: (tour, path) => set({ pendingTour: { tour, path } }),
  clearPendingTour: () => set({ pendingTour: null }),
}));
